import { PermissionsState } from './types';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export { namespace } from './types';

export const state: PermissionsState = {
  currentUserRole: {
    id: '1',
    displayName: 'User Role',
    permissions: [
      /* {
        id: 'accessManagement.read',
        description: 'false',
        permissionType: 'read',
        resourceGroup: '',
        featureGroup: '',
      }, */
      /*   {
        id: 'accessManagement.write',
        description: 'false',
        permissionType: 'write',
        resourceGroup: '',
        featureGroup: '',
      }, */
      /* {
        id: 'userManagement.read',
        description: 'false',
        permissionType: 'read',
        resourceGroup: '',
        featureGroup: 'accessManagement',
      }, */
      /* {
        id: 'userManagement.write',
        description: 'false',
        permissionType: 'write',
        resourceGroup: '',
        featureGroup: 'accessManagement',
      }, */
      /*  {
        id: 'deviceManagement.read',
        description: '',
        permissionType: 'read',
        resourceGroup: '',
        featureGroup: '',
      }, */
      /* {
        id: 'deviceManagement.write',
        description: '',
        permissionType: 'write',
        resourceGroup: '',
        featureGroup: '',
      }, */
      /* {
        id: 'deviceList.read',
        description: '',
        permissionType: 'read',
        resourceGroup: '',
        featureGroup: 'deviceManagement',
      }, */
      /*  {
        id: 'deviceList.write',
        description: '',
        permissionType: 'write',
        resourceGroup: '',
        featureGroup: 'deviceManagement',
      }, */
      /*  {
        id: 'vehiculesTrackingRecord.read',
        description: '',
        permissionType: 'read',
        resourceGroup: '',
        featureGroup: 'deviceManagement',
      }, */
      /*  {
        id: 'vehiculesTrackingRecord.write',
        description: '',
        permissionType: 'write',
        resourceGroup: '',
        featureGroup: 'deviceManagement',
      }, */
      /*  {
        id: 'updateManagement.read',
        description: '',
        permissionType: 'read',
        resourceGroup: 'featureUpdate',
        featureGroup: 'deviceManagement',
      }, */
      /* {
        id: 'updateManagement.write',
        description: '',
        permissionType: 'write',
        resourceGroup: 'featureUpdate',
        featureGroup: 'deviceManagement',
      }, */
      /*  {
        id: 'events.read',
        description: '',
        permissionType: 'read',
        resourceGroup: '',
        featureGroup: 'deviceManagement',
      }, */
      /* {
        id: 'events.write',
        description: '',
        permissionType: 'write',
        resourceGroup: '',
        featureGroup: 'deviceManagement',
      }, */
      /* {
        id: 'tolling.read',
        description: '',
        permissionType: 'read',
        resourceGroup: '',
        featureGroup: '',
      }, */
      /* {
        id: 'tolling.write',
        description: '',
        permissionType: 'write',
        resourceGroup: '',
        featureGroup: '',
      }, */
    ]
  }
};
const namespaced = true;

export const module = {
  namespaced,
  state,
  actions,
  getters,
  mutations
};
